import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import {TransitionProps} from "@mui/material/transitions";
import React, {ChangeEvent, useEffect, useState} from "react";
import agent from "../api/agent";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalState: boolean;
  setSelectedImage: React.Dispatch<React.SetStateAction<File | null>>;
  selectedImage: File | null;
  handleSubmitImage: () => Promise<void>;
  setImageFamilyId: React.Dispatch<React.SetStateAction<undefined>>;
  documentsMVPSelectList: any;
  contractProgressId: number;
}

const ImageUploadModal = ({
  setModalOpen,
  modalState,
  setSelectedImage,
  selectedImage,
  handleSubmitImage,
  setImageFamilyId,
  documentsMVPSelectList,
  contractProgressId,
}: Props) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [currentPhase, setCurrentPhase] = useState();

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    contractProgressId &&
      agent.ContractProgressDeal.getCurrentPhase(contractProgressId).then(
        (response) => {
          setCurrentPhase(response.currentPhaseId);
        }
      );
  }, [contractProgressId]);

  const docNames =
    documentsMVPSelectList &&
    documentsMVPSelectList.filter((item: any) => item.phaseId === currentPhase);

  const handleChangeDocumentId = (e: any) => {
    let {value} = e.target;

    setImageFamilyId(value === 0 ? 1 : value);
  };

  return (
    <Dialog
      open={modalState}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xl"
    >
      <DialogTitle>
        <Typography sx={{fontWeight: 600, fontSize: "20px"}}>
          Select an image to upload
        </Typography>
        <Typography sx={{fontWeight: 400, fontSize: "18px"}}>
          Please upload images in JPEG and/or PNG format only.
        </Typography>
        <Typography sx={{fontWeight: 400, fontSize: "18px"}}>
          If your files are PDFs, export them to JPEG/PNG files before
          uploading.
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid item xs={12}>
          <Select
            sx={{minWidth: "550px", marginBottom: "5px"}}
            labelId="doc-type-label"
            id="doc-type-select"
            onChange={handleChangeDocumentId}
          >
            {docNames &&
              docNames.map((item: any) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.docTypeName}
                </MenuItem>
              ))}
          </Select>
        </Grid>
        <div>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {previewUrl && (
            <img
              src={previewUrl}
              alt="Preview"
              style={{width: "200px", marginTop: "10px"}}
            />
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{
            background: "rgba(4, 119, 130, 1)",
            "&.MuiButtonBase-root:hover": {
              bgcolor: "rgba(1, 150, 164, 1)",
            },
            "&:disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12)",
            },
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(255, 255, 255, 1)",
            borderRadius: "4px",
            letterSpacing: "1.25px",
            textAlign: "center",
            lineHeight: "36px",
            minWidth: "100px",
            height: "40px",
            margin: "15px",
          }}
          onClick={handleSubmitImage}
          disabled={!selectedImage}
        >
          Submit
        </Button>
        <Button
          sx={{
            background: "#fff",
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontSize: "0.875rem",
            fontWeight: "400",
            color: "#047782",
            letterSpacing: "1.25px",
            border: "1px solid #047782",
            borderRadius: "4px",
            margin: "15px",
          }}
          onClick={() => setModalOpen(false)}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageUploadModal;
